import React, { useEffect, useContext } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Color_Restore from '../../Assets/Icons/Icon_Color_Restore.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';

export default function Subwindow_MapEditor_RippleDelete({ zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Confirmer_Respond } = useStatus();
    const { Map_Information_Type } = useMapRenderer();
    const Confirm = (Type) => {
        Confirmer_Respond(true, {Type: Type}, true, "Window_MapEditor_Restore");
        // UI.Subwindows_Close('Window_MapEditor_RippleDelete');
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_MapEditor_Restore");
    }

    useEffect(() => {
        const el = document.getElementById("Window_MapEditor_Restore");
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);

    return (
        <ui-subwindow Type='Modal' id='Window_MapEditor_Restore' State='Inactive' Visibility='Close' style={{width: "500px"}}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control'>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' onClick={Cancel}/>
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Color_Restore} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>

                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Restore
                    {Map_Information_Type == "Building" ? " building"
                        : Map_Information_Type == "Floor" ? " floor"
                            : " room"}
                    ?
                </h2>

                <p className='General_Paragraph' style={{ textAlign: "center", marginBottom: "20px" }}>
                    {/* {Map_Information_Type == "Building" ? "Rooms and floors under it will also be removed."
                        : Map_Information_Type == "Floor" ? "Rooms under it will also be removed." : ""} */}
                    You can choose to restore this item only or restore all the children rooms/floors.
                </p>
                {/* <p className='General_Paragraph' style={{ marginBottom: "20px", textAlign: "center" }}>
                    Removed items can still be restored from the bin.
                </p> */}
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                {Map_Information_Type == "Building" || Map_Information_Type == "Floor" ? 
                    <>
                        <button className='General_Button Subwindow_Control' Type='Secondary' onClick={() => Confirm("Single")}>
                            Restore
                            {Map_Information_Type == "Building" ? " building "
                                : Map_Information_Type == "Floor" ? " floor "
                                    : " room "}
                            only
                        </button>
                        <button className='General_Button Subwindow_Control' Type='Secondary' State='Positive' onClick={() => Confirm("Cascade")}>
                            Restore
                            {Map_Information_Type == "Building" ? " building "
                                : Map_Information_Type == "Floor" ? " floor "
                                    : " room "}
                            and all its children
                        </button>
                    </>
                    :
                    Map_Information_Type == "Room" ?
                        <button className='General_Button Subwindow_Control' Type='Secondary' onClick={() => Confirm("Single")} State="Positive">
                            Restore room
                        </button>
                        :
                        ""
                }
                
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
